import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Taxonomy from './components/Taxonomy.vue';
import Documents from './components/Documents.vue';
import DocumentForm from './components/DocumentForm.vue';
import DocumentAddForm from './components/DocumentAddForm.vue';
import DocumentEditForm from './components/DocumentEditForm.vue';
import DocumentProcesses from './components/DocumentProcesses.vue';
import DocumentPublications from './components/DocumentPublications.vue';
import Importer from './components/Importer.vue';
import DocumentTypes from './components/DocumentTypes.vue';
import PublishingStatuses from './components/PublishingStatuses.vue';
import Lookups from './components/Lookups.vue';
import SpatialCoverage from './components/SpatialCoverage.vue';
import Login from './components/Login.vue';
import { authenticationService } from '@/_services';
import DocumentsSorting from './components/DocumentsSorting.vue';

Vue.use(Router);

export const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'is-active',
  routes: [
    { path: '/', name: 'login', component: Login },
    { path: '/login', name: 'login', component: Login },
    { path: '/taxonomy', name: 'taxonomy', component: Taxonomy },
    { path: '/documents', name: 'documents', component: Documents },
    { path: '/documents/add/:source', name: 'documents_add', component: DocumentForm },
    { path: '/documents/add/', name: 'documents_add', component: DocumentAddForm },
    { path: '/documents/edit/:source', name: 'documents_edit', component: DocumentEditForm },
    { path: '/processes', name: 'processes', component: DocumentProcesses },
    { path: '/publications', name: 'publications', component: DocumentPublications },
    { path: '/importer', name: 'importer', component: Importer },
    {
      path: '/document-type', name: 'document-type',
      component: Lookups, props: { url: '/lookup/document-type' }
    },
    {
      path: '/publish-status', name: 'publish-status',
      component: Lookups, props: { url: '/lookup/publish-status' }
    },
    {
      path: '/frequency', name: 'frequency',
      component: Lookups, props: { url: '/lookup/frequency' }
    },
    { path: '/spatial-coverage', name: 'spatial-coverage', component: SpatialCoverage },
    { path: '/documents-sorting', name: 'documents-sorting', component: DocumentsSorting },
    { path: '*', redirect: '/' }
  ],
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const { authorize } = to.meta;
  const currentUser = authenticationService.currentUserValue;

  if (authorize) {
      if (!currentUser) {
          // not logged in so redirect to login page with the return url
          return next({ path: '/login', query: { returnUrl: to.path } });
      }

      // // check if route is restricted by role
      // if (authorize.length && !authorize.includes(currentUser.role)) {
      //     // role not authorised so redirect to home page
      //     return next({ path: '/' });
      // }
  }


  next();
})
